import { useMemo, useState } from "react";
import { Check, Search } from "lucide-react";
import { Avatar, Presence } from "./Avatar";
import { useChat } from "@/lib/chat";

export const PeoplePicker = ({ selected, onChange, exclude = [], placeholder = "Search by name or handle" }) => {
  const { users, meId } = useChat();
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    return users.filter((u) => u.id !== meId && !u.is_system_bot && u.is_active !== false && !exclude.includes(u.id) && (!s || u.display_name.toLowerCase().includes(s) || u.handle.toLowerCase().includes(s) || (u.chat_email || "").includes(s)));
  }, [users, q, meId, exclude]);
  const toggle = (id) => onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, border: "1px solid #868686", borderRadius: 4, padding: "0 10px", minHeight: 40, flexWrap: "wrap", marginBottom: 10 }}>
        <Search size={16} style={{ color: "var(--tc-text-muted)" }} />
        {selected.map((id) => { const u = users.find((x) => x.id === id); return u ? <span key={id} className="tc-chip"><Avatar user={u} size={18} radius={4} />{u.display_name}<button onClick={() => toggle(id)} style={{ marginLeft: 2 }} aria-label="Remove">×</button></span> : null; })}
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={placeholder} style={{ flex: 1, border: 0, outline: 0, fontSize: 15, minWidth: 120, height: 36 }} data-testid="people-picker-input" autoFocus />
      </div>
      <div className="tc-people-list tc-scroll">
        {list.map((u) => (
          <button key={u.id} className={`tc-people-row${selected.includes(u.id) ? " is-selected" : ""}`} onClick={() => toggle(u.id)} data-testid={`people-row-${u.handle}`}>
            <Avatar user={u} size={24} radius={5} />
            <span>{u.display_name}</span>
            <Presence presence={u.presence} />
            <span className="sub">@{u.handle}</span>
            <span className="right">{selected.includes(u.id) ? <Check size={16} color="var(--tc-link)" /> : u.title}</span>
          </button>
        ))}
        {!list.length && <div style={{ padding: 16, color: "var(--tc-text-muted)", fontSize: 13 }}>No one matches "{q}"</div>}
      </div>
    </div>
  );
};
